import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { timeout } from "../utils/utils";

const Home = () => {
  const { t } = useTranslation();
  const [loadImage, setLoadImage] = useState(false);
  const height = window.innerHeight;
  const width = window.innerWidth;
  const isLaptop = width >= 1100 && height >= 768;
  console.log("what are my dimens? ", width, height);

  useEffect(() => {
    console.log("I mounted");
    (async () => {
      await timeout(350);
      setLoadImage(true);
    })();
  }, []);

  const sendEmail = () => {
    const email = document.createElement("a");
    const subject = t("email_subject");
    const body = t("email_body");
    email.href = `mailto:radixood@gmail.com?body=${body}&subject=${subject}`;
    email.target = "_newtab";
    email.click();
  };

  return (
    <div className="homeSection">
      <div className="home_left">
        <div className="content">
          <div className="content__container">
            <ul className="content__container__list">
              <li className="content__container__list__item">
                <p className="content_title">{t("why_title")}</p>
                <p className="content_text">
                  {isLaptop ? t("why_text") : t("why_text_mobile")}
                </p>
                <p className="why_sizer"></p>
              </li>
              <li className="content__container__list__item">
                <p className="content_title">{t("what_title")}</p>
                <p className="content_text">
                  {isLaptop ? t("what_text") : t("what_text_mobile")}
                </p>
                <p className="what_sizer"></p>
              </li>
              <li className="content__container__list__item">
                <p className="content_title">{t("how_title")}</p>
                <p className="content_text">
                  {isLaptop ? t("how_text") : t("how_text_mobile")}
                </p>
                <ol className="content_ol">
                  <li>{t("how_1")}</li>
                  <li>{t("how_2")}</li>
                  <li>{t("how_3")}</li>
                </ol>
                <p className="how_sizer"></p>
              </li>
            </ul>
          </div>
        </div>
        {loadImage ? (
          <div className="make_inquiry_container">
            <button
              className="make_inquiry_button"
              onClick={() => {
                sendEmail();
              }}
            >
              {t("make_inquiry")}
            </button>
          </div>
        ) : null}
      </div>
      <div className="home_right">
        {loadImage ? (
          <div className="animated-title">
            <div className="text-top">
              <div>
                <span className="slogan_span">{t("radix")}</span>
                <span className="slogan_span">{t("translation_and")}</span>
              </div>
            </div>
            <div className="text-bottom">
              <div>
                <span className="slogan_span"> {t("slogan")}</span>
              </div>
            </div>
          </div>
        ) : null}
        {loadImage ? (
          <img
            className="home_image"
            src="../../white2.png"
            alt="People translating documents"
          />
        ) : null}
        {/* <span>CONTENT HERE....</span> */}
      </div>
    </div>
  );
};

export default Home;
